<geaui-page-content-layout class="users-page">
  <ng-container page-header>
    <geaui-page-header
      pageTitle="Users"
      [hasBackArrow]="false"
      [withSidebar]="true"
    >
      <div class="users-page-header-container">
        <geaui-button-v3
          [disabled]="addUserButtonDisabled"
          [type]="'primary'"
          (click)="onAddNewUserClicked()"
          >Add User</geaui-button-v3
        >
      </div>
    </geaui-page-header>
  </ng-container>

  <ng-container page-content>
    <div
      class="users-content geaui-grid geaui-sidebar-grid geaui-scrollable-table"
    >
      <div
        class="users-filters geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12"
      >
        <geaui-search-bar-v2
          [id]="'search-bar'"
          [group]="searchForm"
          formName="search"
          [placeholder]="searchPlaceholder"
          [showBottomBorderOnly]="true"
          [hasSuggestions]="false"
          [hasProminentButton]="false"
          (valueChanged)="searchValueChanged($event)"
          (clearEvent)="searchValueChanged('')"
        >
        </geaui-search-bar-v2>
        <hrt-filter-chips
          [columnDefinitions]="columnDefinitions"
          [activeChipFilters]="activeChipFilters"
          [globalSearch]="'Users Search'"
          [tableId]="tableId"
          (chipRemoved)="onChipRemoved($event)"
        ></hrt-filter-chips>
      </div>
      <geaui-table-v3
        [tableId]="tableId"
        [columnDefinitions]="columnDefinitions"
        [data]="userResponse"
        [totalRecords]="count"
        [loading]="isTableLoading"
        [isLandingPage]="true"
        [rowsClickable]="true"
        [isLandingPage]="true"
        [sortable]="true"
        (rowClicked)="onRowClicked($event)"
        [nonClickableColumns]="['no_key_actions']"
        [noEntriesInfoText]="'No entries available, try different filters.'"
        [noEntriesTitle]="'No Users Found'"
        class="geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12 geaui-col-tablet-lg-12 geaui-col-tablet-sm-12 geaui-col-phone-lg-8 geaui-col-phone-sm-4"
      ></geaui-table-v3>
    </div>
  </ng-container>
</geaui-page-content-layout>
